import { get } from 'lodash';
import { Platform } from './types';

export class Agent {
  //eslint-disable-next-line
  agentData: any;

  //eslint-disable-next-line
  constructor(dataIn: any) {
    this.agentData = dataIn;
  }

  getId(): string {
    return this.agentData.id || null;
  }

  getSiteId(): string {
    return this.agentData.site || null;
  }

  //eslint-disable-next-line
  getAgent(): any {
    return this.agentData;
  }

  getStatus(): string {
    return this.agentData.status || null;
  }

  getAlias(): string {
    return this.agentData.name || null;
  }

  getIp(): string {
    return this.agentData.ipaddress || null;
  }

  getModel(): string {
    const platformObj = this.agentData.params.find(param => {
      return param.name === 'model';
    });

    return platformObj.value || null;
  }

  getPlatform(): Platform {
    const platformObj = this.agentData.params.find(param => {
      return param.name === 'platform';
    });

    return platformObj.value || null;
  }

  getLastHeartBeatDate(): string {
    const platformObj = this.agentData.params.find(param => {
      return param.name === 'lastHeartBeatTime';
    });

    return platformObj.value || null;
  }

  getMac(): string {
    const platformObj = this.agentData.params.find(param => {
      return param.name === 'mack';
    });

    return platformObj.value || null;
  }

  getVersion(): string {
    const platformObj = this.agentData.params.find(param => {
      return param.name === 'version';
    });

    return platformObj.value || null;
  }

  isDeleted(): boolean {
    return get(this, 'agentData.deleted', false);
  }
}
